import React from 'react'
import { defaultProps } from './index'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'

export const IdealeSectionSettings = ({ floating }: any) => {
  const themeOpts = [
    { label: 'Light', value: 'light' },
    { label: 'Neutral light', value: 'neutrallight' },
    { label: 'Dark Secondary', value: 'secondarydark' },
    { label: 'Black', value: 'black' },
    { label: 'Primary', value: 'primary' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          label="Tema"
          options={themeOpts}
          defaultValue={defaultProps.theme}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="primaryIcon"
          type="icon"
          label="Icona"
          defaultValue={defaultProps.primaryIcon}
        />
      </ToolbarSection>
      {!floating && (
        <>
          <ImageToolbarSection defaultProps={defaultProps} initOpen />
          <LayoutToolbarSection defaultProps={defaultProps} />
        </>
      )}
    </>
  )
}

export const IdealeSectionFloatingSettings = () =>
  React.createElement(IdealeSectionSettings, { floating: true })
